import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import swal from "sweetalert2";
import * as xlsx from 'xlsx';
import { Client } from 'src/app/models/client';
import { Company } from 'src/app/models/company';
import { environment } from 'src/environments/environment';
import { AccessService } from '../../services/access.service';
import { ClientService } from 'src/app/services/client.service';
import { CompanyService } from '../../services/company.service';
import { UtilsService } from 'src/app/services/utils.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss'],
  providers: [UtilsService, ClientService, AccessService, CompanyService]
})
export class ClientComponent implements OnInit {
  // MODELS VARIABLE
  public client = {} as Client;
  public company = {} as Company;
  public userCode: number;
  public storeCode: number;
  public companyCode: number;
  public isEdit: boolean;
  public isDisabled: boolean;
  public noCredit: boolean;
  public settings = {
    columns: {
      clientBusinessCode: {
        title: 'Código'
      },
      clientName: {
        title: 'Nombre'
      },
      clientTaxDocument: {
        title: 'RUC/CI'
      },
      clientDV: {
        title: 'Dígito Verificador'
      },
      TipoCliente: {
        title: 'Tipo Ident.',        
      },
      TipoRuc: {
        title: 'Tipo Contribuyente',
      },
      clientPhone: {
        title: 'Teléfono'
      },
      clientAddress: {
        title: 'Dirección'
      },
      clientEmail: {
        title: 'Correo'
      },
      clientIdDepto: {
        title: 'Cod. Departamento',
      },
      clientDescDepto: {
        title: 'Departamento',
      },
      clientIdDistrito: {
        title: 'Cod. Distrito',
      },
      clientDescDistrito: {
        title: 'Distrito',
      },
      clientIdCiudad: {
        title: 'Cod. Ciudad',
      },
      clientDescCiudad: {
        title: 'Ciudad',
      }
    }
  };
  public url: string;
  loading;

  // VARIABLE FOR DATA TABLE
  public test: any = `<button (click)="onSelect($event)">Click me</button>`;
  public entries: number = 10;
  public selected: any[] = [];
  public temp = [];
  public activeRow: any;
  public clientList: Client[] = new Array();

  // VARIABLE FOR SELECT 
  public categoryList: any[] = new Array();
  public selectedItems = [];
  public dropdownSettings = {};

  public tipoCliente: number;
  public DVCliente: boolean = false;

  // DATA SELECT ADDRESS CLIENT
  public idProvincia: number;
  public itemNameProvincia: string;
  public selectedItemsProvincia = [];
  public ProvinciaList: any[] = new Array();
  public dropdownSettingsProvincia: IDropdownSettings = {};
  closeDropdownSelectionProvincia = false;

  public idDistritos: number;
  public itemNameDistritos: string;
  public selectedItemsDistritos = [];
  public DistritosList: any[] = new Array();
  public dropdownSettingsDistritos: IDropdownSettings = {};
  closeDropdownSelectionDistritos = false;

  public idCorregimientos: number;
  public itemNameCorregimientos: string;
  public selectedItemsCorregimientos = [];
  public CorregimientosList: any[] = new Array();
  public dropdownSettingsCorregimientos: IDropdownSettings = {};
  closeDropdownSelectionCorregimientos = false;

  public nextCursor: number | null = 0;
  public hasMore = true;

  constructor(
    private cdref: ChangeDetectorRef,
    private _utilsService: UtilsService,
    private _accessService: AccessService,
    private _clientService: ClientService,
    private _companyService: CompanyService
  ) { 
    this.url = environment.url;
    //this.url = 'http://localhost:4200/';
  }

  async ngOnInit() {
    // GET ID USER & ID COMPANY
    const _data = JSON.parse(localStorage.getItem('data'));
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    // SET VARIABLE
    this.isEdit = false;
    this.noCredit = true;
    this.isDisabled = false;
    this.client.clientDiscount = 0;
    this.client.clientType = 4;
    this.client.clientTR = "4";
    this.client.clientDV = "0";
    this.tipoCliente = 0;
    this.client.clientEmail = 'magoldfacturacion@gmail.com';
    this.client.clientAddress = '';

    // LOAD INFORMATION
    this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
    this.getClientCategory();
    this.getSelectSetting(this.selectedItems);
    await this.getCompany(this.companyCode);
    //this.selectedItems = [{ 'id': 1, 'itemName': 'Tipo A' }]

    await this.getAddresClientList(1, 0);
    this.getSelectSettingProvincia(this.selectedItemsProvincia);
  }

  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  getAddresClientList(type, code) {

    let addresC ={
      type: type,
      code: code
    }

    return this._clientService.getAddressClient(addresC).then(
      response => {
        if (response.result) {

          if (type == 1) {
            this.ProvinciaList = response.records.map((item: any) => ({
              ...item,
              nombreCompleto: item.cod_provincia + ' - ' + item.nombre
            }));
            console.log("ProvinciaList ->" + JSON.stringify(response.records));
          }
          else if (type == 2) {
            this.DistritosList = response.records.map((item: any) => ({
              ...item,
              nombreCompleto: item.cod_distrito + ' - ' + item.nombre
            }));
            console.log("DistritosList ->" + JSON.stringify(response.records));
          }
          else if (type == 3) {
            this.CorregimientosList = response.records.map((item: any) => ({
              ...item,
              nombreCompleto: item.cod_corregimiento + ' - ' + item.nombre
            }));
            console.log("CorregimientosList ->" + JSON.stringify(response.records));
          }
          
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async onItemSelectProvincia(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemProvincia = await this.ProvinciaList.find(x => x.cod_provincia == item.cod_provincia);
    console.log(_selectedItemProvincia);

    this.idProvincia = item.cod_provincia;
    this.itemNameProvincia = _selectedItemProvincia.nombre;

    this.client.clientIdDepto = this.idProvincia;
    this.client.clientDescDepto = this.itemNameProvincia;

    this.loading = true;
    await this.getAddresClientList(2, item.cod_provincia);
    this.getSelectSettingDistrito(this.selectedItemsDistritos);
    
    this.client.clientDescDistrito = "";
    this.client.clientDescCiudad = "";    
    this.client.clientIdDistrito = 0;
    this.client.clientIdCiudad = 0;
    this.loading = false;
  }

  async onItemSelectDistrito(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemDistrito = await this.DistritosList.find(x => x.cod_distrito == item.cod_distrito);
    console.log(_selectedItemDistrito);

    this.idDistritos = item.cod_distrito;
    this.itemNameDistritos = _selectedItemDistrito.nombre;

    this.client.clientIdDistrito = this.idDistritos;
    this.client.clientDescDistrito = this.itemNameDistritos;

    this.loading = true;
    await this.getAddresClientList(3, this.idProvincia);
    this.getSelectSettingCorregimiento(this.selectedItemsCorregimientos);
    this.client.clientDescCiudad = "";
    this.client.clientIdCiudad = 0;
    this.loading = false;
  }

  async onItemSelectCorregimiento(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemCorregimiento = await this.CorregimientosList.find(x => x.cod_corregimiento == item.cod_corregimiento);
    console.log(_selectedItemCorregimiento);

    this.idCorregimientos = item.cod_corregimiento;
    this.itemNameCorregimientos = _selectedItemCorregimiento.nombre;

    console.log('CodDireccion -> ', this.idProvincia, this.idDistritos, this.idCorregimientos);
    console.log('Descripcion -> ', this.itemNameProvincia, this.itemNameDistritos, this.itemNameCorregimientos);

    this.client.clientIdCiudad = this.idCorregimientos;
    this.client.clientDescCiudad = this.itemNameCorregimientos;

    console.log('Direccion Cliente -> ', this.client.clientIdDepto, this.client.clientDescDepto, this.client.clientIdDistrito, this.client.clientDescDistrito, this.client.clientIdCiudad, this.client.clientDescCiudad);
  }

  getSelectSettingProvincia(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsProvincia = [selected] : '';

    this.dropdownSettingsProvincia = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_provincia',
      textField: 'nombreCompleto'
    };
  }

  getSelectSettingDistrito(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsDistritos = [selected] : '';

    this.dropdownSettingsDistritos = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_distrito',
      textField: 'nombreCompleto'
    };
  }

  getSelectSettingCorregimiento(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsCorregimientos = [selected] : '';

    this.dropdownSettingsCorregimientos = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_corregimiento',
      textField: 'nombreCompleto'
    };
  }

  ///////////////////////FUNCTION FOR TABLE///////////////////////
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase(); 
    this.temp = this.clientList.filter(function (d) {

      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ///////////////////////FUNCTION FOR SELECT///////////////////////  
  getSelectSetting(selected) {
    Object.keys(selected).length > 0 ? this.selectedItems = [selected] : '';

    this.dropdownSettings = {
      singleSelection: true,
      text: "Seleccione...",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: ""
    };
  };

  getClientCategory() {
    return this._clientService.getAllClientCategory().then(
      response => {
        if (response.result) {
          response.records.forEach(e => {
            this.categoryList.push({
              id: e.clientCategoryCode,
              itemName: e.clientCategoryName
            });
          });

        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  onItemSelect(item: any) {
    this.client.clientCategory = item.id;
  }

  ///////////////////////CRUD///////////////////////
  // GET ALL CLIENT
  getAll() {
    this.loading = true;
    return this._clientService.getAll().then(
      response => {
        if (response.result) {
          this.clientList = response.records;
          this.temp = this.clientList;
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  // GET ALL CLIENT BY COMPANY
  getAllByCompany() {
    this.loading = true;
    // return this._clientService.getAllByCompany(this.companyCode).then(
    return this._clientService.getAllByCompanyPaginated(this.companyCode, 3500, 0).then(
      response => {
        if (response.result) {
          console.log(response.records);
          this.clientList = response.records;
          this.temp = this.clientList;
          this.nextCursor = response.nextCursor;
          this.hasMore = response.hasMore;

          console.log('NextCursor', this.nextCursor);
          console.log('HasMore', this.hasMore);

          const fetchMoreClients = async () => {
            while (this.hasMore) {
              try {
                const response = await this._clientService.getAllByCompanyPaginated(this.companyCode, 3500, this.nextCursor);
                if (response.result) {
                  this.clientList = this.clientList.concat(response.records);
                  this.temp = this.clientList;
                  this.nextCursor = response.nextCursor;
                  this.hasMore = response.hasMore;

                  console.log('NextCursor', this.nextCursor);
                  console.log('HasMore', this.hasMore);
                } else {
                  console.log(response.message);
                  break;
                }
              } catch (error) {
                console.log(error);
                break;
              }
            }
          };
          fetchMoreClients();

        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  // GET ONE CLIENT
  viewFunction($event) {
    $event.preventDefault();

    swal.fire({
      title: "Empresa:",
      html:
        '<div class="text-left">' +
        '<b>Nombre: </b>' + this.activeRow.clientName + '<br>' +
        '<b>Teléfono: </b>' + this.activeRow.clientPhone + '<br>' +
        '<b>Correo: </b>' + this.activeRow.clientEmail + '<br>' +
        '<b>Dirección: </b>' + this.activeRow.clientAddress + '<br></div>',
      customClass: {
        confirmButton: "btn btn-success",
      },
      width: 650,
      confirmButtonText: "Aceptar",
      buttonsStyling: false
    })
  }

  onChangeTypeClient(event) {
    this.client.clientType = event;
    this.tipoCliente = event;
    event == 0 ? this.DVCliente = true : this.DVCliente = false;
    // this.DVCliente = true;
    if (event == 0) {
      this.client.clientTR = "2"; // RUC -> Juridico - Contribuyente
    } else if (event == 1) {
      this.client.clientTR = "1"; // CI -> Natural - No Contribuyente
    }
    console.log('Tipo identificación', this.tipoCliente);
  }

  onChangeTypeRUC(event) {    
    this.client.clientTR = event;
    // this.tipoCliente = event;
    console.log('Tipo RUC', this.client.clientTR);
  }

  // INSERT
  save() {
    console.log(this.client.clientCategory);
    this.loading = true;
    this.isDisabled = true;
    this.client.clientStatus = 1;
    this.client.clientDeleted = 0;

    this.client.clientCompanyCode = this.companyCode;
    this.client.clientCredit ? this.client.clientCredit = 1 : this.client.clientCredit = 0;
    this.client.clientBlocked ? this.client.clientBlocked = 1 : this.client.clientBlocked = 0;
    this.client.clientCreditTime == undefined ? this.client.clientCreditTime = 0 : '';
    this.client.clientCreditAmount == undefined ? this.client.clientCreditAmount = 0 : '';
    this.client.clientInterest == undefined ? this.client.clientInterest = 0 : '';
    this.client.clientPhone2 == undefined ? this.client.clientPhone2 = "0000-0000" : '';
    this.client.clientAddressFrequent == undefined ? this.client.clientAddressFrequent = "CIUDAD" : '';
    this.client.clientCategory == undefined ? this.client.clientCategory = 1 : '';

    const requiredFields = [
      'clientBusinessCode',
      'clientName',
      'clientTaxDocument',
      'clientDV',
      'clientType',
      'clientTR',
      'clientPhone',
      'clientAddress',
      'clientEmail',
      'clientDescDepto',
      'clientDescDistrito',
      'clientDescCiudad'
    ];

    for (const field of requiredFields) {
      if (
        this.client[field] === undefined ||
        this.client[field] === null ||
        (typeof this.client[field] === 'string' && this.client[field].trim() === '')
      ) {
        this._utilsService.showNotification(3, `El campo "${this.settings.columns[field]?.title || field}" es obligatorio.`);
        this.isDisabled = false;
        this.loading = false;
        return;
      }
    }

    if (this.client.clientType == 4) {
      this._utilsService.showNotification(3, 'El campo "Tipo Identificación" es obligatorio.');
      this.isDisabled = false;
      this.loading = false;
      return;
    }

    if (this.client.clientTR == "4") {
      this._utilsService.showNotification(3, 'El campo "Tipo Contribuyente" es obligatorio.');
      this.isDisabled = false;
      this.loading = false;
      return;
    }

    const nameRegex = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/;
    if (!nameRegex.test(this.client.clientName)) {
      this._utilsService.showNotification(3, 'El campo "Nombre" solo permite letras.');
      this.isDisabled = false;
      this.loading = false;
      return;
    }
    // if (!nameRegex.test(this.client.clientAddress)) {
    //   this._utilsService.showNotification(3, 'El campo "Dirección" solo permite letras.');
    //   this.isDisabled = false;
    //   this.loading = false;
    //   return;
    // }
    
    // const phoneRegex = /^(\d{2,3}-\d{6}|\d{4}-\d{4})$/;
    // if (!phoneRegex.test(this.client.clientPhone)) {
    //   this._utilsService.showNotification(3, 'El campo "Teléfono" debe tener el formato 000-000000 o 00-000000 o 0000-0000 y solo permite números y un guion medio.');
    //   this.isDisabled = false;
    //   this.loading = false;
    //   return;
    // }

      console.log(this.clientList);

    if(this.client.clientTaxDocument == "CF"){

      const Client3 = this.clientList.find(({ clientBusinessCode }) => clientBusinessCode == this.client.clientBusinessCode);
      console.log('Cliente Buscado 3', Client3);
      if(Client3 != undefined){
        //Existe
        this._utilsService.showNotification(3, "Código de Cliente ya existe.");
        this.isDisabled = false;
        this.loading = false;
        return;        
      }

      if(this.client.clientName.toUpperCase() == "CONSUMIDOR FINAL"){
        this._utilsService.showNotification(3, "CF no pueden tener como nombre Consumidor Final.");
        this.isDisabled = false;
        this.loading = false;
      }
      else{
        console.log('model client', this.client);
        this.client.clientTaxDocument = this.client.clientTaxDocument;
        this.client.clientDV = "0";
        this.client.clientTR = "1";
        this.client.clientNameFrequent == undefined ? this.client.clientNameFrequent = this.client.clientName : '';
        this.client.clientBussinesCode = this.client.clientBusinessCode;
        this._clientService.insert(this.client).then(
          (response) => {
        if (response.result == true) {
              this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
              this.cleanModel();
              this._utilsService.showNotification(1, response.message);
            } else {
              this._utilsService.showNotification(3, response.errorMessage);
            }
          },
          error => {
            this._utilsService.showNotification(2, error);
            console.log(error);
          }
        ).finally(() => {
          this.isDisabled = false;
          this.loading = false;
        });
      }

    }
    else{
      
      return this._clientService.getOneByCompanyNit(this.companyCode, this.client.clientTaxDocument).then(
        response => {
          if (response.records.length > 0) {
            //Cliente ya existe
            this._utilsService.showNotification(3, "Documento Tributario del Cliente ya existe.");
            this.isDisabled = false;
            this.loading = false;
          }
          else {
            
            // const Client = this.clientList.find(({ clientEmail }) => clientEmail == this.client.clientEmail);
            // console.log('Cliente Buscado', Client);
            // if(Client == undefined){
              //No existe
              const Client2 = this.clientList.find(({ clientPhone }) => clientPhone == this.client.clientPhone);
              console.log('Cliente Buscado 2', Client2);

              const Client3 = this.clientList.find(({ clientBusinessCode }) => clientBusinessCode == this.client.clientBusinessCode);
              console.log('Cliente Buscado 3', Client3);
              if(Client3 != undefined){
                //Existe
                this._utilsService.showNotification(3, "Código de Cliente ya existe.");
                this.isDisabled = false;
                this.loading = false;
                return;        
              }
              // if(Client2 == undefined){
              if(1 == 1){
                //No existe
                //Cliente nuevo

                if(this.client.clientType == 2){

                  this.client.clientName = this.client.clientName;
                  this.client.clientNameFrequent == undefined ? this.client.clientNameFrequent = this.client.clientName : '';
                  this._utilsService.showNotification(4, "Cliente Nuevo");

                  console.log('model client', this.client);
                  this._clientService.insert(this.client).then(
                    (response) => {
                      if (response.result == true) {
                        this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
                        this.cleanModel();
                        this._utilsService.showNotification(1, response.message);
                      } else {
                        this._utilsService.showNotification(3, response.errorMessage);
                      }
                    },
                    error => {
                      this._utilsService.showNotification(2, error);
                      console.log(error);
                    }
                  ).finally(() => {
                    this.isDisabled = false;
                    this.loading = false;
                  });

                }
                else{

                  console.log('model client', this.client);
                  this.client.clientTaxDocument = this.client.clientTaxDocument;
                  // this.client.clientDV = "0";
                  // this.client.clientTR = "1";
                  this.client.clientNameFrequent == undefined ? this.client.clientNameFrequent = this.client.clientName : '';
                  this._clientService.insert(this.client).then(
                    (response) => {
                      if (response.result == true) {
                        this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
                        this.cleanModel();
                        this._utilsService.showNotification(1, response.message);
                      } else {
                        this._utilsService.showNotification(3, response.errorMessage);
                      }
                    },
                    error => {
                      this._utilsService.showNotification(2, error);
                      console.log(error);
                    }
                  ).finally(() => {
                    this.isDisabled = false;
                    this.loading = false;
                  });

                  // let dataClient = {
                  //   transmitter: {
                  //     transmitterPrefix: this.company.companyPrefix,
                  //     transmitterToken: this.company.companyToken,
                  //     transmitterTaxDocument: this.company.companyTaxDocument
                  //   },
                  //   client: {
                  //     ruc: this.client.clientTaxDocument,
                  //     tipoRuc: this.client.clientTR,
                  //   }
                  // };

                  // this._clientService.searchRUCPY(dataClient).then(
                  //   async response => {
                  //     if (response.Ok) {
                  //       //this.client.clientName = response.nombre[0];
                  //       //console.log(response.nombre[0]);
                  //       this.client.clientName =  response.Nombre;
                  //       this.client.clientDV = response.DV;
                  //       this.client.clientTR = response.TipoRuc;
                  //       this.client.clientNameFrequent == undefined ? this.client.clientNameFrequent = this.client.clientName : '';
                  //       this._utilsService.showNotification(4, "Cliente Nuevo");
    
                  //       console.log('model client', this.client);
                  //       this._clientService.insert(this.client).then(
                  //         (response) => {
                  //           if (response.result == true) {
                  //             this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
                  //             this.cleanModel();
                  //             this._utilsService.showNotification(1, response.message);
                  //           } else {
                  //             this._utilsService.showNotification(3, response.errorMessage);
                  //           }
                  //         },
                  //         error => {
                  //           this._utilsService.showNotification(2, error);
                  //           console.log(error);
                  //         }
                  //       ).finally(() => {
                  //         this.isDisabled = false;
                  //         this.loading = false;
                  //       });
    
                  //     } else {
                  //       this._utilsService.showNotification(3, 'Cliente no encontrado en DIGIFACT');
                  //     }
                  //   },
                  //   error => {
                  //     console.log(error);
                  //   }
                  // );

                }                              
              }
              else{
                //Existe
                this._utilsService.showNotification(3, "Número de Telefono de Cliente ya existe.");
                this.isDisabled = false;
                this.loading = false;
              }
            // }
            // else{
            //   //Existe
            //   this._utilsService.showNotification(3, "Correo del cliente ya existe.");
            //   this.isDisabled = false;
            //   this.loading = false;
            // }
          }
        },
        error => {
          console.log(error);
        }
      ).finally(() => {
        this.isDisabled = false;
        this.loading = false;
      }); 
      
    }         
  }

  // UPDATE
  update() {
    this.loading = true;
    this.isDisabled = true;

    this.client.clientCredit ? this.client.clientCredit = 1 : this.client.clientCredit = 0;
    this.client.clientBlocked ? this.client.clientBlocked = 1 : this.client.clientBlocked = 0;
    this.client.clientAddressFrequent == undefined ? this.client.clientAddressFrequent = "0000-0000" : '';
    this.client.clientPhone2 == undefined ? this.client.clientPhone2 = "0000-0000" : '';

    // console.log(this.client);
    this._clientService.update(this.client).then(
      async (response) => {
        if (response.result == true) {
          this.isEdit = false;
          this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
          this.cleanModel();
          this._utilsService.showNotification(1, response.message);
        } else {
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        console.log(error);
        this._utilsService.showNotification(2, error);
      }
    ).finally(() => {
      this.loading = false;
      this.isDisabled = false;
    });

    // return this._clientService.getOneByCompanyNit(this.companyCode, this.client.clientTaxDocument).then(
    //   response => {
    //     if (response.records.length > 0) {
    //       //Cliente ya existe
    //       if(response.records[0].clientCode != this.client.clientCode){
    //         this._utilsService.showNotification(3, "Documento Tributario del Cliente ya existe.");
    //         this.isDisabled = false;
    //         this.loading = false;
    //         return;
    //       }
    //     }
    //     else{
          
    //       // console.log(this.client);
    //       this._clientService.update(this.client).then(
    //         async (response) => {
    //           if (response.result == true) {
    //             this.isEdit = false;
    //             this.companyCode === 1 ? this.getAll() : this.getAllByCompany();
    //             this.cleanModel();
    //             this._utilsService.showNotification(1, response.message);
    //           } else {
    //             this._utilsService.showNotification(3, response.errorMessage);
    //           }
    //         },
    //         error => {
    //           console.log(error);
    //           this._utilsService.showNotification(2, error);
    //         }
    //       ).finally(() => {
    //         this.loading = false;
    //         this.isDisabled = false;
    //       });

    //     }
    //   },
    //   error => {
    //     console.log(error);
    //   }
    // ).finally(() => {
    //   this.isDisabled = false;
    //   this.loading = false;
    // });
  }

  // DELETED
  deleteFunction($event) {
    $event.preventDefault();

    this.client.clientCode = this.activeRow.clientCode;
    this.client.clientStatus = 0;
    this.client.clientDeleted = 1;

    swal.fire({
      title: "Esta seguro",
      text: "El cliente se eliminara definitivamte!",
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      confirmButtonText: "Si, eliminar!",
      buttonsStyling: false
    }).then(result => {
      if (result.value) {
        this.update();
        swal.fire({
          title: "Enviado!",
          text: "Se ha mandado la solicitud.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-success",
          },
          buttonsStyling: false
        });
      }
    });
  }

  // LOAD DATA TO EDIT
  editFunction($event) {
    $event.preventDefault();
    this.isEdit = true;

    console.log('activeRow Cliente', this.activeRow);

    this.client.clientCode = this.activeRow.clientCode;
    this.client.clientCompanyCode = this.activeRow.clientCompanyCode;
    // this.client.clientBussinesCode = this.activeRow.clientBusinessCode;
    this.client.clientBusinessCode = this.activeRow.clientBusinessCode;
    this.client.clientName = this.activeRow.clientName;
    this.client.clientTaxDocument = this.activeRow.clientTaxDocument;
    this.client.clientEmail = this.activeRow.clientEmail;
    this.client.clientPhone = this.activeRow.clientPhone;
    this.client.clientPhone2 = this.activeRow.clientPhone2;
    this.client.clientAddress = this.activeRow.clientAddress;
    this.client.clientAddressFrequent = this.activeRow.clientAddressFrequent;
    this.client.clientCategory = this.activeRow.clientCategory;
    this.client.clientCreditTime = this.activeRow.clientCreditTime;
    this.client.clientCreditAmount = this.activeRow.clientCreditAmount;
    this.client.clientBlocked = this.activeRow.clientBlocked;
    this.client.clientType = this.activeRow.clientType;
    this.client.clientNameFrequent = this.activeRow.clientNameFrequent;
    this.client.clientTR = this.activeRow.clientTR;
    this.DVCliente = this.activeRow.clientType == 0 ? true : false;
    this.client.clientDV = this.activeRow.clientDV;
    this.client.clientDescDepto = this.activeRow.clientDescDepto;
    this.client.clientDescDistrito = this.activeRow.clientDescDistrito;
    this.client.clientDescCiudad = this.activeRow.clientDescCiudad;
    this.client.clientIdDepto = this.activeRow.clientIdDepto;
    this.client.clientIdDistrito = this.activeRow.clientIdDistrito;
    this.client.clientIdCiudad = this.activeRow.clientIdCiudad;

    this.activeRow.clientCredit == 1 ? this.client.clientCredit = true : this.client.clientCredit = false;
    this.activeRow.clientBlocked == 1 ? this.client.clientBlocked = true : this.client.clientBlocked = false;

    const _selectedItem = this.categoryList.find(x => x.id == this.activeRow.clientCategory);
    this.getSelectSetting(_selectedItem);
  }

  billing($event) {
    $event.preventDefault();
    console.log('activeRow Client',this.activeRow);     
    swal.fire({
      title: 'Nota',
      text: "Se abrira una pestaña nueva",
      icon: "warning",
      width: 750,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'Factura Normal',
      denyButtonText: 'Factura Exenta',
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-success",
        denyButton: "btn btn-warning",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {
      if (result.isDismissed) {
        //console.log('candelado')
        console.log(this.company);
        console.log('activeRow Client',this.activeRow);        
      } else {
        let billingType;        
        this.company.companyInvoiceType == 1 ? billingType = 'inventory' : billingType = 'description';

        localStorage.setItem(
          "clientData",
          JSON.stringify(this.activeRow)
        );

        if (result.isConfirmed) {
          window.open(this.url + billingType + '-billing?nit=' + this.activeRow.nit);
        } else if (result.isDenied) {
          window.open(this.url + 'inventory-exenta-billing?nit=' + this.activeRow.nit);
          console.log('Exenta');
        }
      }
    })
  }

  //BILLING CLIENT
  // billing($event) {
  //   $event.preventDefault();
  //   let billingType;
  //   this.company.companyInvoiceType == 1 ? billingType = 'inventory' : billingType = 'description';
  //   window.open(this.url + billingType + '-billing?nit=' + this.activeRow.nit);
  // }

  ///////////////////////COMPLEMENT///////////////////////
  creditFunction() {
    this.client.clientCredit == true ? this.noCredit = false : this.noCredit = true;
    this.client.clientInterest = null;
    this.client.clientCreditTime = null;
    this.client.clientCreditAmount = null;
  }

  //CANCEL EDIT
  cancelUpdate($event) {
    this.cleanModel();
    this.isEdit = false;
  }

  // CLEAR MODAL
  cleanModel() {
    this.isDisabled = false;
    this.client = {} as Client;
    this.selectedItems = null;
    this.client.clientIdDepto = this.idProvincia;
    this.client.clientDescDepto = this.itemNameProvincia;
    this.client.clientIdDistrito = this.idDistritos;
    this.client.clientDescDistrito = this.itemNameDistritos;
    this.client.clientIdCiudad = this.idCorregimientos;
    this.client.clientDescCiudad = this.itemNameCorregimientos;

    //this.selectedItems = [{ 'id': 1, 'itemName': 'Tipo A' }]
    // this.client.clientCategory = 1;
    this.client.clientDiscount = 0;
    this.client.clientCompanyCode = this.companyCode;
    this.client.clientAddress = '';
    this.client.clientDiscount = 0;
    this.client.clientType = 4;
    this.client.clientTR = "4";
    this.client.clientDV = "0";
    this.tipoCliente = 0;
    this.client.clientEmail = 'magoldfacturacion@gmail.com';
    this.isEdit = false;
    this.noCredit = true;
    this.isDisabled = false;
    this.DVCliente = false;

    this.client.clientDescDepto = "";
    this.client.clientDescDistrito = "";
    this.client.clientDescCiudad = "";
    this.client.clientIdDepto = 0;
    this.client.clientIdDistrito = 0;
    this.client.clientIdCiudad = 0;
  }

  // DESCARGAR EXCEL
  async downloadToExcel() {
    const checkList = this.temp;
    const exportFile = new Array<any>();

    checkList.forEach(element => {
      let json = {};
      Object.keys(this.settings.columns).forEach((item, index, arr) => {
        if (this.settings.columns[item].type === "number") {
          json[this.settings.columns[item].title] = parseFloat(element[item]);
        } else {
          json[this.settings.columns[item].title] = element[item];
        }
      });
      exportFile.push(json);
    });
    const ws: xlsx.WorkSheet =
      xlsx.utils.json_to_sheet(exportFile);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
    xlsx.writeFile(wb, 'reporte-cliente.xlsx');
  }
}
